import omit from 'lodash/omit';

import style from './SubNav.module.css';

import type { NavigationItem } from '../../../NavItem';
import { NavItem } from '../../../NavItem';
import { Text } from '../../../Text';
import { type AppNavItem } from '../types';

interface SubNavProps {
  items: AppNavItem[];
}

/** Render the sub navigation (only for small viewports). */
export function SubNav(props: SubNavProps) {
  return (
    <nav role="navigation" className={style.subNav}>
      <div role="list" className={style.list} aria-label="Sub navigation">
        {props.items.length > 0 &&
          props.items
            .map(item => omit(item, 'alwaysVisible') as NavigationItem)
            .map((item, i) => (
              <Text key={i} role="listitem" className={style.listItem}>
                <NavItem key={i} {...item} />
              </Text>
            ))}
      </div>
    </nav>
  );
}
